import State from 'store/State';

export const selectDarkVenueMappingsState = (state: State) =>
    state.darkVenueMappings;
